import React, { Component } from 'react'
import BodyComponent from './body'

/**
 * @augments {Component<import('./interfaces').BodyProps>}
 */
class Body extends Component {
  static getClassName (props) {
    return BodyComponent.getClassName(props)
  }

  get className () {
    return BodyComponent.getClassName(this.props)
  }

  render () {
    return <BodyComponent {...this.props} />
  }
}

Body.propTypes = BodyComponent.propTypes

export default Body
